import { createFileRoute, redirect } from '@tanstack/react-router'

// /about is a vanity alias for the company page — it carries no content of its
// own and redirects straight to /company. Same pattern as /demo: this handles
// client-side navigation within the SPA; the build also emits a static
// dist/about/index.html meta-refresh stub (scripts/prerender.ts) so a direct
// hit or a crawler redirects without booting the SPA. Kept out of ROUTE_META so
// it stays out of the sitemap and isn't indexed as its own page.
export const Route = createFileRoute('/about')({
  beforeLoad: () => {
    throw redirect({ to: '/company/' })
  },
})
